module.exports = __webpack_public_path__ + "img/icon-completed-task.ebd75fde.svg";